/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import useSize from '../../../../../../hooks/useSize'
import {SearchInput} from '../../../../../components/SearchInput'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'

type Props = {
  className: string
  plants: any[]
  formik: any
}

const ListPlantsLinked: React.FC<Props> = ({className, plants, formik}) => {
  const [mySearch, setMySearch] = useState([])
  const [control, setControl] = useState(false)
  const [initialSelectedPlantId, setInitialSelectedPlantId] = useState<string | null>(null)
  const hasCapturedInitialSelection = useRef(false)
  const {width} = useSize()

  // Captura a usina pré-selecionada só no primeiro carregamento da lista
  useEffect(() => {
    if (hasCapturedInitialSelection.current) return
    if (!plants?.length) return

    if (formik.values.idPlant) {
      if (plants.some((plant: any) => plant.id === formik.values.idPlant)) {
        setInitialSelectedPlantId(formik.values.idPlant)
        hasCapturedInitialSelection.current = true
      }
      return
    }

    hasCapturedInitialSelection.current = true
  }, [plants, formik.values.idPlant])

  const sortSelectedFirst = (list: any[]) => {
    if (!initialSelectedPlantId || !list?.length) return list || []
    return [...list].sort((a, b) => {
      const aSelected = a.id === initialSelectedPlantId ? 0 : 1
      const bSelected = b.id === initialSelectedPlantId ? 0 : 1
      return aSelected - bSelected
    })
  }

  const orderedPlants = useMemo(
    () => sortSelectedFirst(plants),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [plants, initialSelectedPlantId]
  )

  const orderedSearch = useMemo(
    () => sortSelectedFirst(mySearch),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mySearch, initialSelectedPlantId]
  )

  const updateData = (value: string, checked: boolean) => {
    if (checked === true) {
      formik.setFieldValue('idPlant', value)
    } else {
      formik.setFieldValue('idPlant', null)
    }
  }

  const renderPlantRow = (plant: any) => (
    <div
      key={plant.id}
      className='d-flex align-items-center mb-7'
      style={{justifyContent: 'space-between'}}
    >
      <div className='d-flex align-items-center'>
        <div className='symbol symbol-50px me-5'>
          <span
            className='symbol-label'
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          >
            <div
              className='symbol symbol-50px'
              style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            >
              <img src={toAbsoluteUrl('/media/imgs/plant2.png')} className='' alt='' />
            </div>
          </span>
        </div>
        <div className='d-flex flex-column'>
          <a href='#' className='text-dark text-hover-primary fs-6 fw-bold'>
            {plant.name}
          </a>
          <span className='text-muted fw-semibold'>
            {plant.address ? plant.address : 'Não localizado.'}
          </span>
        </div>
      </div>
      <div className='form-check form-check-custom form-check-success form-check-solid mx-5'>
        <input
          className={`form-check-input ${
            formik.values.idPlant === plant.id ? 'bg-primary' : 'bg-secondary'
          }`}
          type='checkbox'
          checked={formik.values.idPlant === plant.id ? true : false}
          value={plant.id}
          onChange={(e) => {
            updateData(e.target.value, e.target.checked)
          }}
        />
      </div>
    </div>
  )

  return (
    <div className={`card ${className}`} style={{paddingBottom: '2rem'}}>
      <div
        className='card-header border-0 pt-5'
        style={{display: 'flex', flexDirection: 'row'}}
      >
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>Usina Vinculada à Proposta</span>
        </h3>

        <SearchInput
          className={`form-control form-control-solid bg-body ps-14 ${
            width < 1200 ? 'fs-7' : 'fs-7'
          }`}
          placeholder='Buscar pelo Nome'
          myDate={plants}
          setMySearch={setMySearch}
          control={control}
          style={{width: width < 1200 ? '100%' : '200px', height: '3rem'}}
          setControl={setControl}
          searchParameter='name'
        />
      </div>

      <div className='card-body pt-5' style={{height: '20rem', overflowY: 'auto'}}>
        {plants && plants.length > 0 ? (
          control ? (
            orderedSearch.map((plant: any) => renderPlantRow(plant))
          ) : (
            orderedPlants.map((plant: any) => renderPlantRow(plant))
          )
        ) : (
          <div
            className='d-flex align-items-center mb-7'
            style={{height: '100%', justifyContent: 'center'}}
          >
            <h3 className='card-title align-items-start flex-column'>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Não há usinas vinculadas.
              </span>
            </h3>
          </div>
        )}
      </div>
    </div>
  )
}

export {ListPlantsLinked}
